import { Tag } from 'antd';
import styled from 'styled-components';

export const StyledPropagationTag = styled(Tag)`
  && {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    margin: 0;
    background: ${({ theme }) => theme.secondaryBackgroundColor};
    border-color: ${({ theme }) => theme.teal};
    color: ${({ theme }) => theme.textColor};
  }
`;

export const EmptyPropagationTag = styled(Tag)`
  && {
    margin: 0;
    background: ${({ theme }) => theme.secondaryBackgroundColor};
    border-style: dashed;
    border-color: ${({ theme }) => theme.buttonBorderColor};
    color: ${({ theme }) => theme.textColor};
  }
`;

// A button around a Tag, so the pill keeps the Tag's look and still takes focus.
export const TagButton = styled.button`
  all: unset;
  display: inline-flex;
  cursor: pointer;

  &:focus-visible {
    outline: auto;
  }

  &:hover > .ant-tag {
    background: ${({ theme }) => theme.tealBackgroundColor};
    border-color: ${({ theme }) => theme.teal};
  }
`;
